<template>
  <ValidationObserver ref="formService">
    <form novalidate @submit.prevent="saveChanges">
      <div class="row">
        <div class="col-8">
          <breadcrumb :page="page" />
        </div>
        <div class="col-4 text-right">
          <router-link
            to="/pei/detail?tab=Tab8"
            tag="button"
            class="btn btn-green"
          >
            <i class="fas fa-arrow-circle-left" />
            <span class="pl-2">Regresar</span>
          </router-link>
          <button
            v-if="hasPermission && !disabledAll"
            type="button"
            class="btn btn-green"
            @click="saveChanges()"
          >
            <i class="fas fa-save" />
            <span class="pl-2">Guardar</span>
          </button>
        </div>
        <div class="col-12">
          <div class="dropdown-divider mt-0 pb-2 w-100 mb-4" />
          <div class="tab-content">
            <SectionTitle
              :content="'Información de Servicio'"
              :has-line="true"
            />

            <Error
              v-if="
                model.transportationRequieredFlag &&
                  !model.hasTransportRequestQuestionaire &&
                  !isPS
              "
              is-alert-mode
              :message="resources['P90003']"
            />

            <!-- Education Service Component -->
            <EducationalService
              v-if="enableEducationServiceControl"
              ref="educationalServiceRef"
              :modality-list="services.modalityList"
              :approach-list="services.approachList"
              :duration-list="services.durationList"
              :frequency-list="services.frequencyList"
              :service-type-title="model.peiDisciplineName"
              :is-approach-required="educationalServiceIsApproachRequired"
              :disabled-all="disabledAll"
              :show-modality-warning="showModalityWarning"
              :alternate-placement-is-salon-regular="
                model.peiAlternatePlacementRecommendedIsSalonRegular
              "
              @on-change-modality="onModalityChange"
              @on-change-approach="onApproachChange"
              @on-change-duration="onDurationChange"
              @on-change-frequency="onFrequencyChange"
            />

            <!-- Therapy Service Component  -->
            <TherapyService
              v-if="enableTherapyServiceControl"
              ref="therapyServiceRef"
              :modality-list="services.modalityList"
              :duration-list="services.durationList"
              :frequency-list="services.frequencyList"
              :service-type-title="model.peiDisciplineName"
              :disabled-all="disabledAll"
              @on-change-remedy="onChangeRemedy"
              @on-change-modality="onModalityChange"
              @on-change-duration="onDurationChange"
              @on-change-frequency="onFrequencyChange"
              @on-change-service-reason="onServiceReasonChange"
            />

            <!-- Adapted Physical Component -->
            <AdaptedPhysicalEducationService
              v-if="enablePhysicalEducationServiceControl"
              ref="adaptedPhysicalEducationServiceRef"
              :hide-teacher-type="hideTeacherSelection"
              :master-type-list="services.masterTypeList"
              :modality-list="services.modalityList"
              :duration-list="services.durationList"
              :frequency-list="services.frequencyList"
              :service-type-title="model.peiDisciplineName"
              :disabled-master-type="
                adaptedPhysicalEducationServiceDisabledMasterType
              "
              :disabled-all="disabledAll"
              @on-change-modality="onModalityChange"
              @on-change-master-type="onMasterTypeChange"
              @on-change-duration="onDurationChange"
              @on-change-frequency="onFrequencyChange"
            />

            <!-- Deaf Service Component -->
            <DeafService
              v-if="enableDeafServiceControl"
              ref="deafServiceRef"
              :hide-teacher-type="hideTeacherSelection"
              :master-type-list="services.masterTypeList"
              :modality-list="services.modalityList"
              :duration-list="services.durationList"
              :frequency-list="services.frequencyList"
              :service-type-title="model.peiDisciplineName"
              :disabled-master-type="deafServiceDisabledMasterType"
              :disabled-all="disabledAll"
              @on-change-modality="onModalityChange"
              @on-change-master-type="onMasterTypeChange"
              @on-change-duration="onDurationChange"
              @on-change-frequency="onFrequencyChange"
            />

            <ServiceStatusInfo
              v-if="canShowServiceStatusSection"
              :services="model.serviceStatusesInfo"
            />

            <div v-if="canShowTransportationDiv" class="row">
              <div class="col">
                <SectionTitle
                  :content="'Información de Transportación'"
                  :has-line="true"
                />
                <!-- Mostrar la pregunta solo para cuando el parametro de cuestionario de transportación sea visible siempre -->
                <ValidationProvider
                  v-if="!isNewTransportationLogic"
                  v-slot="{ errors }"
                  name="¿El estudiante requiere transportación?"
                  rules="required"
                  mode="eager"
                >
                  <WizardQuestion
                    id="qQuestionsTransp"
                    :ref="'transportationRequiredFlag'"
                    v-model="model.transportationRequieredFlag"
                    :description="'¿El estudiante requiere transportación?'"
                    :answer-control-type="1"
                    :has-icon="true"
                    :icon="'fa fa-bus'"
                    error-message="mensaje"
                    :on-change="onChangeTranspInfo"
                    :is-disabled="disabledRequiredTransportation || disabledAll"
                  />
                  <Error
                    v-if="errors && errors.length > 0"
                    variant="no-border"
                    :message="errors[0]"
                  />
                </ValidationProvider>

                <div v-if="shouldShowTransportQuestionnaire" class="row">
                  <div class="col">
                    <ServiceQuestionnaire
                      ref="serviceQuestionnaire"
                      v-if="
                        requiredTransportation != null &&
                          transportRequestQuestion.length > 0
                      "
                      v-model="transportationModel"
                      :key="serviceQuestionnaireKey"
                      :questionary-id="requiredTransportation.id"
                      :questions="transportRequestQuestion"
                      :is-valid="questionnaireValid"
                      :is-validated="false"
                      :questionnaire-status="questionnaireStatus"
                      :transport-type="transportType"
                      :show-transport-type="showTransportType"
                      :questionary-number="
                        requiredTransportation.questionnaireNumber
                      "
                      :questionary-disabled="disabledAll"
                      :is-therapy-service="isTherapyService"
                      :pei-service-type-id="peiServiceTypeId"
                      @onTransportTypeChange="onTransportTypeChange"
                      @on-edit="onEditHandler"
                      @on-update="updateAnalisysServiceData"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isTherapyService" class="row separator-box">
              <ServiceEvaluation
                :rows="evaluations"
                :has-result-summary="hasResultSummary"
                :program-service-area-id="model.programServiceAreaId"
                :upload-document="this.handlerUploadDocument"
                warning-msg="Favor de relacionar una evaluación con el Servicio Relacionado"
                :disabled-all="disabledAll"
                @on-add="onAddServiceClick"
                @show-evaluation-history="onShowEvaluationHistoryHandler"
              />
            </div>
            <div v-if="isTherapyService" class="row separator-box">
              <div class="col">
                <SectionTitle
                  :content="'Documentos añadidos'"
                  :has-line="true"
                />
                <ServiceDocument
                  ref="serviceDocuments"
                  :disabled-all="disabledAll"
                  :student-service-id="model.studentServiceId"
                  :analysis-service-id="model.analysisServiceId"
                  :is-therapy="isTherapyService"
                  :has-result-summary="hasResultSummary"
                  :has-achievement-summary="hasAchievementSummary"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import uniqueId from 'lodash/uniqueId';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store/index';
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import WizardQuestion from '@/components/pei/WizardQuestion';
import { SectionTitle } from '@/components/pei/shared';
import { ServiceQuestionnaire } from '@/components/pei/service/components/questionnaire';
import ServiceStatusInfo from '@/components/pei/service/components/ServiceStatusInfo';
import {
  EducationalService,
  TherapyService,
  DeafService,
  AdaptedPhysicalEducationService,
} from './components/information-service';
import generalService from '@/services/pei/general';

import mixWait from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import PeiAnalysisService from '../../../utils/constants/pei/peiAnalysisService';
import Error from '@/components/common/Error';

import {
  ServiceDocument,
  ServiceEvaluation,
} from '@/components/pei/service/components';
import resourcesService from '@/services/resources.js';
import peiGeneralService from '@/services/pei/general';
import transportationServiceAddressTypes from '@/utils/constants/pei/transportationServiceAddressTypes.js';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import transportationQuestionnaireEnum from '@/utils/constants/pei/transportation/transportationQuestionnaire';
import yesOrNotEnum from '@/utils/constants/yesOrNotEnum';
import PeiCode from '@/utils/constants/pei/peiCode';
import modalityTypes from '@/utils/constants/pei/modalityTypes';
import PeiAnalysisServiceCodes from '@/utils/constants/pei/peiAnalysisService';
import approachTypes from '@/utils/constants/approachTypes';
import peiTeacherType from '@/utils/constants/pei/peiTeacherType';
import academicYears from '@/utils/constants/academicYears';

const PEI_BORRADOR_STATUS_CODE = 1;
const APPROACH_TYPE_ENABLED_ITEMS = [497, 496, 495];
const TRANSPORTACION = 1937;
const PORTEADOR = 141;
export default {
  name: 'Service',
  mixins: [mixWait, alert],
  data() {
    return {
      page: {
        icon: 'fas fa-file-alt',
        title: 'Servicios',
        routes: [
          'Inicio',
          'PEI',
          'Análisis de Alternativa de Ubicación y Servicios',
          'Servicios',
        ],
      },
      showModalityWarning: false,
      activateAssistantServiceNeedGuideIsOn: false,
      enableAlwaysVisibleTransportationQuestionnaireParam: false,
      serviceQuestionnaireKey: uniqueId(),
      resources: [],
      educationServiceControlCode: 1,
      therapyServiceControlCode: 2,
      physicalEducationServiceControlCode: 3,
      deafServiceControlCode: 4,
      disabledRequiredTransportation: false,
      enableEducationServiceControl: false,
      enableTherapyServiceControl: false,
      enablePhysicalEducationServiceControl: false,
      enableDeafServiceControl: false,
      model: {
        transportationRequieredFlag: null,
        cognitiveAnswer: null,
      },
      transportationModel: {
        serviceType: 0,
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: 0,
        acompanyCode: '',
        mileage: 0,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
      },
      requiredTransportation: null,
      selectedOption: {
        id: 'Seleccione',
        name: 'Seleccione',
      },
      evaluations: [],
      questionnaireValid: true,
      questionnaireStatus: '',
      showTransportType: false,
      transportType: '261', //1. No required, 2. Regular, 3.Carrier, 4.Scholarship
      transportRequestQuestion: [],
      services: {
        durationList: [],
        frequencyList: [],
        modalityList: [],
        masterTypeList: [],
        approachList: [],
      },
      deafServiceDisabledMasterType: false,
      adaptedPhysicalEducationServiceDisabledMasterType: true,
      educationalServiceIsApproachRequired: true,
      disabledAll: false,
      peiAnalysisService: PeiAnalysisService,
    };
  },
  computed: {
    isYear2027OrHigher() {
      return this.model?.peiAcademicYear >= 2027;
    },
    hasPermission() {
      return store.getters.HasPermission('pei.create');
    },
    hideTeacherSelection() {
      return (
        this.model.peiAnalysisServiceCode ==
        PeiAnalysisServiceCodes.LenguajeSenas
      );
    },
    selectedEvaluation() {
      // JSF: filter by selected evaluation and then sort them by date
      const selectedEvalutions = this.evaluations
        .filter((x) => x.isSelected)
        .sort(
          (a, b) =>
            new Date(b.evaluationDate).getTime() -
            new Date(a.evaluationDate).getTime()
        );
      if (selectedEvalutions && selectedEvalutions.length > 0) {
        const mostRecentEvaluation = selectedEvalutions[0];
        return mostRecentEvaluation;
      }

      return null;
    },
    ...mapGetters({
      selectedPeiStatus: 'SelectedPeiStatus',
      peiServiceTypeId: 'getServiceTypeId',
      serviceTypeId: 'getAnalysisServiceId',
    }),
    immediateFileSave() {
      return !!this.model.studentServiceId;
    },
    isNotDraft() {
      return this.selectedPeiStatus !== PEI_BORRADOR_STATUS_CODE;
    },
    isDraft() {
      return this.selectedPeiStatus === PEI_BORRADOR_STATUS_CODE;
    },
    isEducativeService() {
      return this.peiAnalysisService.Educativo == this.peiServiceTypeId;
    },
    isTherapyService() {
      let result = false;
      if (
        this.peiAnalysisService.TerapiaDeHabla == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaOcupacional == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaPsicológica == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaFísica == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaOromotora == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaEducativa == this.peiServiceTypeId ||
        this.peiAnalysisService.TerapiaDisfagia == this.peiServiceTypeId ||
        this.peiAnalysisService.Otros == this.peiServiceTypeId
      ) {
        result = true;
      }

      return result;
    },
    peiId() {
      return store.getters.SelectedPei;
    },
    isPS() {
      return store.getters.getIsPs;
    },
    hasResultSummary() {
      return this.$route.params.hasResultSummary;
    },
    hasAchievementSummary() {
      return this.$route.params.hasAchievementSummary;
    },
    modalityId() {
      return this.model.peiModalityCode;
    },
    isIllegalDuration() {
      if (
        !this.model.peiDurationCode > 0 ||
        this.services.durationList.length === 0
      )
        return false;

      return (
        this.services.durationList.findIndex(
          (x) => x.id === this.model.peiDurationCode
        ) === -1
      );
    },
    isTransportationLogicActive() {
      return this.model.isTransportationLogicActive === true;
    },
    canShowServiceStatusSection() {
      return (
        this.isTherapyService &&
        this.peiServiceTypeId != this.peiAnalysisService.Otros &&
        this.isTransportationLogicActive
      );
    },
    canShowTransportationSection() {
      // JSF: US46525 - always show tranport section for types Educative and other.
      const serviceTypesBypass = [
        this.peiAnalysisService.Otros,
        this.peiAnalysisService.Educativo,
      ];
      if (
        serviceTypesBypass.some((typeId) => this.peiServiceTypeId == typeId)
      ) {
        return true;
      }

      const services = this.model.serviceStatusesInfo;
      const saee = services?.find((x) => !x.isRemPro);

      let canShowForRp = services.find((x) => x.isRemPro);
      let canShowForSaee = services.find((x) => !x.isRemPro);

      // then check if has contract (if apply)
      if (canShowForRp) {
        const rempro = services.find((x) => x.isRemPro);
        const hasContract = rempro.statusId > 0;
        canShowForRp = hasContract && !!rempro?.typeOfPlace;
      }

      // if it's not active then don't show the transportation's section
      if (canShowForSaee) {
        canShowForSaee = !!saee?.typeOfPlace;
      }

      return (
        (this.canShowServiceStatusSection &&
          (canShowForRp || canShowForSaee)) ||
        store.getters.HasPermission('pei.tab8.services.transportation')
      );
    },
    canShowTransportationSectionForPS() {
      let canShow = this.isTransportationLogicActive
        ? this.canShowTransportationSection
        : !this.isPS;
      return canShow;
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered.validation;
    },
    // Nueva lógica: Parámetro para activar lógica del cuestionario de transportación sea visible siempre esta encendido ahi se muestra en cuestionario directamente
    isNewTransportationLogic() {
      return this.enableAlwaysVisibleTransportationQuestionnaireParam;
    },
    // Determina si se debe mostrar el cuestionario de transporte
    shouldShowTransportQuestionnaire() {
      // Si es la nueva lógica (parametro en true), siempre mostrar el cuestionario
      // Si es la lógica antigua, mostrar solo si transportationRequieredFlag es true
      return (
        this.isNewTransportationLogic || this.model.transportationRequieredFlag
      );
    },
    // Condición para mostrar la sección de transportación
    canShowTransportationDiv() {
      return (
        this.canShowTransportationSectionForPS &&
        !this.disabledRequiredTransportation &&
        (!this.canShowServiceStatusSection || this.canShowTransportationSection)
      );
    },
  },
  watch: {
    isIllegalDuration(value) {
      if (value) {
        this.model.peiDurationCode = null;
      }
    },
    'transportationModel.departureCode'(value) {
      if (value) {
        this.getDepartureData(value);
      }
    },
    'transportationModel.placeCode'(value) {
      if (value) {
        this.getPlaceData(value);
      }
    },
  },
  methods: {
    onTransportTypeChange(newValue) {
      this.transportType = newValue;
      this.model.peiTransportationStatus = newValue;
    },
    setTransportationDisability(isDisabled) {
      const transportationRef = this.$refs.transportationRequiredFlag;

      if (transportationRef)
        this.$refs.transportationRequiredFlag.disabled = isDisabled;
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200155',
        'R03200156',
        '0525',
        'P90003',
      ]);
    },
    async initAnalysisService() {
      const { data: frequencyData } = await this.loadFrequencyType();
      if (frequencyData) {
        this.services.frequencyList = frequencyData;
      }

      const { data: teacherData } = await this.loadServiceTeacherType();
      if (teacherData) {
        this.services.masterTypeList = teacherData;
      }

      //Selected educational service
      const { data: serviceData } = await this.getAnalysisService();

      if (serviceData) {
        store.dispatch('setPeiTransportationInfo', {
          departureCode: serviceData.peiAnalysisServiceDepartureCode,
          placeCode: serviceData.peiAnalysisServiceLocationCode,
          specialEquipmentCode: serviceData.peiSpecialEquipmentCode,
          acompanyCode: serviceData.companionFlag ? '1' : '0',
          millaje: serviceData.mileage,
          startDate: serviceData.startDate,
          endDate: serviceData.endDate,
          peiAnalysisServiceCode: serviceData.peiAnalysisServiceCode,
          justification: serviceData.justification,
        });

        this.model = serviceData;

        //educational service
        if (this.educationServiceControlCode == this.model.visualControlCode) {
          this.enableEducationServiceControl = true;
          this.$nextTick(async () => {
            const {
              data: modalityData,
            } = await this.loadEducationServiceModalityType();
            if (modalityData) {
              this.services.modalityList = modalityData;

              if (this.model.peiAlternatePlacementRecommendedIsSalonRegular) {
                this.services.modalityList = modalityData.filter(
                  (c) => c.id == modalityTypes.SalonRegular
                );
              }
            }

            await this.setDropDownEducationalService();
            await this.loadApproachtypes();
          });
        } else {
          if (
            this.physicalEducationServiceControlCode ==
            this.model.visualControlCode
          ) {
            const {
              data: modalityData,
            } = await this.loadTherapiesModalityType();
            if (modalityData) {
              this.services.modalityList = modalityData;
            }
          } else {
            const { data: modalityData } = await this.loadModalityType();
            if (modalityData) {
              this.services.modalityList = modalityData;
            }
          }
        }

        //therapy service
        if (this.therapyServiceControlCode == this.model.visualControlCode) {
          this.enableTherapyServiceControl = true;
          this.$nextTick(async () => {
            await this.setDropDownTherapyServiceRef();
          });
        }

        //physical education service
        if (
          this.physicalEducationServiceControlCode ==
          this.model.visualControlCode
        ) {
          this.enablePhysicalEducationServiceControl = true;
          this.disabledRequiredTransportation = true;
          this.setTransportationDisability(true);
          this.$nextTick(async () => {
            await this.setDropDownAdaptedPhysicalEducationServiceRef();
          });
        }
        // deaf service
        if (this.deafServiceControlCode == this.model.visualControlCode) {
          this.enableDeafServiceControl = true;
          this.disabledRequiredTransportation = true;
          this.setTransportationDisability(true);
          this.$nextTick(async () => {
            await this.getDurations();
            await this.setDropDownDeafServiceRef();
          });
        }
        //JSF: Load Referral Documents if isTherapy
        if (this.isTherapyService) {
          //ECG:Load Referral Documents
          if (this.model.studentServiceId) {
            this.$refs.serviceDocuments.getDocuments();
          }
        }
      }

      await this.loadStudentevaluations();
    },
    handlerUploadDocument(paramStudentEval, file) {
      if (file.files[0].type == 'application/pdf') {
        let requestData = new FormData();
        requestData.append(
          'studentEvaluationId',
          paramStudentEval.studentEvaluationId
        );
        requestData.append('attachment', file.files[0]);
        requestData.append('fileName', file.files[0].name);
        requestData.append('documentTypeId', 1);
        requestData.append('documentTitle', 'Evaluación');

        this.$ApiPost(
          '/api/studentEvaluation/SaveStudentEvaluationDocument',
          requestData
        )
          .then(async (response) => {
            response.data.id != undefined;
            {
              await this.loadStudentevaluations();

              this.ShowToast(
                'Proceso exitoso.',
                this.resources['R03200155'],
                'success'
              );
            }
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      } else {
        this.ShowToast('Atención', this.resources['R03200156'], 'error');
      }
      file.value = '';
    },
    async checkValidations(continuityWithSameDefinition) {
      let hasRequiredIncompleteCompleteQuestionary =
        this.model.transportationRequieredFlag == true &&
        (this.questionnaireStatus == '' ||
          this.questionnaireStatus == 'Pendiente');

      if (
        !this.isPS &&
        hasRequiredIncompleteCompleteQuestionary &&
        this.requiredTransportation == null
      ) {
        this.ShowToast(
          'Atención',
          'Debe contestar la sección de cuestionario para continuar.',
          'error'
        );
        return false;
      }

      if (
        !this.isPS &&
        this.requiredTransportation != null &&
        this.model.transportationRequieredFlag &&
        !this.showTransportType
      ) {
        this.ShowToast(
          'Atención',
          'Debe contestar la sección de cuestionario para continuar.',
          'error'
        );
        return false;
      }
      if (
        this.isTherapyService &&
        !continuityWithSameDefinition &&
        this.evaluations &&
        this.selectedEvaluation == null
      ) {
        this.ShowToast(
          'Atención',
          'Favor de relacionar una evaluación con el Servicio Relacionado.',
          'error'
        );
        return false;
      }

      const isValid = await this.$refs.formService.validate();
      if (!isValid) {
        this.ShowToast(
          'Campos vacios',
          'Favor llenar campos requeridos',
          'error'
        );
        return false;
      }

      return true;
    },
    getFormData() {
      let formData = new FormData();
      formData.append('peiId', this.model.peiId);
      formData.append('analysisServiceId', this.model.analysisServiceId);
      formData.append('frequencyCode', this.model.peiFrequencyCode);
      formData.append(
        'peiAnalysisServiceCode',
        this.model.peiAnalysisServiceCode
      );
      formData.append('therapyDurationId', this.model.peiDurationCode);
      formData.append(
        'provisionalRemedyFlag',
        this.model.provisionalRemedyFlag
      );
      formData.append('justification', this.transportationModel.justification);
      formData.append(
        'peiCompanionFlag',
        this.transportationModel.acompanyCode
      );

      formData.append('therapyServiceReason', this.model.therapyServiceReason);

      if (this.peiServiceTypeId)
        formData.append('disciplineTypeId', this.peiServiceTypeId);

      if (this.model.peiModalityCode)
        formData.append('modalityCode', this.model.peiModalityCode);

      if (this.model.transportationRequieredFlag != undefined) {
        formData.append(
          'transportationRequieredFlag',
          this.model.transportationRequieredFlag
        );
      }

      if (this.model.approachTypeId)
        formData.append('approachTypeId', this.model.approachTypeId);

      if (this.model.peiTeacherTypeCode)
        formData.append('teacherTypeCode', this.model.peiTeacherTypeCode);

      if (this.transportationModel.specialEquipmentCode)
        formData.append(
          'peiSpecialEquipmentCode',
          this.transportationModel.specialEquipmentCode
        );

      if (this.transportationModel.placeCode) {
        formData.append(
          'peiAnalysisServiceLocationCode',
          this.transportationModel.placeCode
        );
        formData.append(
          'placeAddress.locationTypeId',
          this.transportationModel.placeCode
        );

        if (this.transportationModel.place) {
          Object.entries(this.transportationModel.place).forEach((prop) => {
            if (prop[1] != null) {
              formData.append(`placeAddress.${prop[0]}`, prop[1]);
            }
          });
        }
      }

      if (this.transportationModel.departureCode) {
        formData.append(
          'peiAnalysisServiceDepartureCode',
          this.transportationModel.departureCode
        );
        formData.append(
          'departureAddress.locationTypeId',
          this.transportationModel.departureCode
        );

        if (this.transportationModel.departure) {
          Object.entries(this.transportationModel.departure).forEach((prop) => {
            if (prop[1] != null) {
              formData.append(`departureAddress.${prop[0]}`, prop[1]);
            }
          });
        }
      }

      if (this.model.peiTransportationStatus)
        formData.append(
          'peiTransportationStatus',
          this.model.peiTransportationStatus
        );

      formData.append('peiMillaje', Number(this.transportationModel.mileage));

      if (this.transportationModel.startDate)
        formData.append(
          'startDate',
          new Date(this.transportationModel.startDate).toISOString()
        );

      if (this.transportationModel.endDate)
        formData.append(
          'endDate',
          new Date(this.transportationModel.endDate).toISOString()
        );

      if (this.model.peiCompanionFlag)
        formData.append('peiCompanionFlag', this.model.peiCompanionFlag);

      if (this.selectedEvaluation)
        formData.append(
          'SelectedStudentEvaluationId',
          this.selectedEvaluation.studentEvaluationId
        );

      if (this.$refs.serviceDocuments != undefined) {
        this.$refs.serviceDocuments.getAddedFiles().forEach((e) => {
          formData.append(
            'AddedFiles',
            e.document,
            e.document.name + '|' + e.category.id + '|' + e.name
          );
        });
      }

      return formData;
    },
    async saveChanges() {
      const { data: continuityResponse } = await this.$ApiGet(
        `/api/pei/servicecontinuitydata`,
        this.model.serviceContinuityCheckData
      );
      let continuityWithSameDefinition =
        continuityResponse.isContinuousWithSameDefinition;
      if (
        this.isTherapyService &&
        continuityWithSameDefinition &&
        (this.model.peiFrequencyCode != continuityResponse.frequencyTypeId ||
          this.model.peiDurationCode != continuityResponse.durationTypeId ||
          this.model.peiModalityCode != continuityResponse.modalityTypeId)
      ) {
        const answer = await this.ShowCancelModal(
          'Atención',
          this.resources['0525'],
          'Sí',
          'No'
        );
        if (answer) {
          continuityWithSameDefinition = false;
        } else {
          return;
        }
      }

      if (
        this.isTherapyService &&
        continuityResponse.isContinuous &&
        this.model.peiFrequencyCode == continuityResponse.oldFrequencyTypeId &&
        this.model.peiDurationCode == continuityResponse.oldDurationTypeId &&
        this.model.peiModalityCode == continuityResponse.oldModalityTypeId
      ) {
        continuityWithSameDefinition = true;
      }

      if (!this.disabledAll) {
        const isValid = await this.checkValidations(
          continuityWithSameDefinition
        );
        if (!isValid) return;

        const formData = this.getFormData();

        const res = await this.$ApiPost(
          '/api/pei/updatepeianalysisservice',
          formData,
          {
            body: {},
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        ).catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });

        if (res.status == 200) {
          this.ShowToast(
            'Proceso exitoso.',
            'Sus datos han sido guardados exitosamente.',
            'success'
          );
          if (res.data.studentServiceId) {
            this.model.studentServiceId = res.data.studentServiceId;

            if (this.isTherapyService) {
              this.$refs.serviceDocuments.clearAddedFiles();
              this.$nextTick(() => {
                this.$refs.serviceDocuments.getDocuments();
              });
            }
          }

          await this.loadStudentevaluations();
        }
      }
    },
    setDropDownEducationalService() {
      if (this.model.peiFrequencyCode) {
        this.$refs.educationalServiceRef.selectedFrequency = {
          id: this.model.peiFrequencyCode,
          name: this.model.peiFrequencyDescription,
        };
        this.disabledEducationalApproachDropDown(this.model.peiFrequencyCode);
      } else {
        this.$refs.educationalServiceRef.selectedFrequency = null;
      }

      const modalities = this.services.modalityList;
      let modalityOption;
      if (modalities.length === 1) {
        modalityOption = {
          id: modalities[0].id,
          name: modalities[0].name,
        };
      } else if (this.model.peiModalityCode) {
        modalityOption = {
          id: this.model.peiModalityCode,
          name: this.model.peiModalityDescription,
        };
        this.educationalServiceIsApproachRequired = false;
      } else {
        modalityOption = null;
      }

      this.$refs.educationalServiceRef.selectedModality = modalityOption;
      if (modalityOption) this.onModalityChange(modalityOption);
    },
    setDropDownTherapyServiceRef() {
      if (this.model.peiFrequencyCode)
        this.$refs.therapyServiceRef.selectedFrequency = {
          id: this.model.peiFrequencyCode,
          name: this.model.peiFrequencyDescription,
        };
      else this.$refs.therapyServiceRef.selectedFrequency = null;

      if (this.model.peiDurationCode)
        this.$refs.therapyServiceRef.selectedDuration = {
          id: this.model.peiDurationCode,
          name: this.model.peiDurationDescription,
        };
      else this.$refs.therapyServiceRef.selectedDuratio;

      if (this.model.peiModalityCode) {
        this.$refs.therapyServiceRef.selectedModality = {
          id: this.model.peiModalityCode,
          name: this.model.peiModalityDescription,
        };

        this.getDurations();
      } else this.$refs.therapyServiceRef.selectedModality = null;
      this.$refs.therapyServiceRef.provisionalRemedyValue =
        this.model.provisionalRemedyFlag === 'U'
          ? null
          : this.model.provisionalRemedyFlag;

      this.$refs.therapyServiceRef.therapyServiceReason = this.model.therapyServiceReason;
    },
    setDropDownAdaptedPhysicalEducationServiceRef() {
      if (this.model.peiFrequencyCode)
        this.$refs.adaptedPhysicalEducationServiceRef.selectedFrequency = {
          id: this.model.peiFrequencyCode,
          name: this.model.peiFrequencyDescription,
        };
      else
        this.$refs.adaptedPhysicalEducationServiceRef.selectedFrequency = null;

      if (this.model.peiDurationCode)
        this.$refs.adaptedPhysicalEducationServiceRef.selectedDuration = {
          id: this.model.peiDurationCode,
          name: this.model.peiDurationDescription,
        };
      else
        this.$refs.adaptedPhysicalEducationServiceRef.selectedDuration = null;

      if (this.model.peiModalityCode)
        this.$refs.adaptedPhysicalEducationServiceRef.selectedModality = {
          id: this.model.peiModalityCode,
          name: this.model.peiModalityDescription,
        };
      else
        this.$refs.adaptedPhysicalEducationServiceRef.selectedModality = null;

      if (this.model.peiTeacherTypeCode) {
        this.$refs.adaptedPhysicalEducationServiceRef.selectedMasterType = {
          id: this.model.peiTeacherTypeCode,
          name: this.model.peiTeacherTypeDescription,
        };
      } else
        this.$refs.adaptedPhysicalEducationServiceRef.selectedMasterType = null;

      this.disabledRequiredTransportation = true;

      if (this.$refs['transportationRequiredFlag'] != null) {
        this.setTransportationDisability(true);
      }
    },
    setDropDownDeafServiceRef() {
      if (this.model.peiFrequencyCode !== null)
        this.$refs.deafServiceRef.selectedFrequency = {
          id: this.model.peiFrequencyCode,
          name: this.model.peiFrequencyDescription,
        };
      else this.$refs.deafServiceRef.selectedFrequency = null;

      if (this.model.peiDurationCode !== null)
        this.$refs.deafServiceRef.selectedDuration = {
          id: this.model.peiDurationCode,
          name: this.model.peiDurationDescription,
        };
      else this.$refs.deafServiceRef.selectedDuration = null;

      if (this.model.peiTeacherTypeCode !== null) {
        this.$refs.deafServiceRef.selectedMasterType = {
          id: this.model.peiTeacherTypeCode,
          name: this.model.peiTeacherTypeDescription,
        };
        this.deafServiceDisabledMasterType = true;

        let modalitiesList = [...this.services.modalityList];
        this.services.modalityList = [];
        if (
          this.model.peiTeacherTypeCode == peiTeacherType.Itinerante &&
          this.isYear2027OrHigher
        ) {
          this.services.modalityList = modalitiesList.filter(
            (c) => c.id == modalityTypes.ServicioMixto
          );
          if (this.services.modalityList.length == 1) {
            this.onModalityChange(this.services.modalityList[0]);
          }
        }
      } else this.$refs.deafServiceRef.selectedMasterType = null;

      this.disabledRequiredTransportation = true;
      this.setTransportationDisability(true);
    },
    getAnalysisService() {
      return this.$ApiGet(
        '/api/pei/getpeianalysisservice?analysisServiceId=' + this.serviceTypeId
      );
    },
    async loadTherapyDuration() {
      const isTherapy = true;

      return await peiGeneralService.getDurations(
        this.peiId,
        this.modalityId,
        isTherapy
      );
    },
    async loadEducationDuration() {
      return await peiGeneralService.getDurations(this.peiId, this.modalityId);
    },
    loadFrequencyType() {
      return this.$ApiGet('/api/pei/frequencyType');
    },
    async loadModalityType() {
      const isTherapy = false;
      const isTherapyTypeOther = true;

      return await peiGeneralService.getServiceModalityTypes(
        this.peiId,
        isTherapy,
        isTherapyTypeOther
      );
    },
    async loadEducationServiceModalityType() {
      return await peiGeneralService.getServiceModalityTypes(this.peiId);
    },
    async loadTherapiesModalityType() {
      const isTherapy = true;
      return await peiGeneralService.getServiceModalityTypes(
        this.peiId,
        isTherapy
      );
    },
    loadServiceTeacherType() {
      return this.$ApiGet('/api/pei/serviceteachertype');
    },
    async loadApproachtypes() {
      const disciplineTypeCd = this.model.peiAnalysisServiceCode
        ? this.model.peiAnalysisServiceCode
        : 0;
      const serviceModalityId = this.model.peiModalityCode
        ? this.model.peiModalityCode
        : 0;
      let url = '/api/pei/getcodeapproachtypes';

      url +=
        '?disciplineTypeCd=' +
        disciplineTypeCd +
        '&serviceModalityId=' +
        serviceModalityId;
      const { data: approachData } = await this.$ApiGet(url);

      const canSetDisabledApproachType =
        this.$refs?.educationalServiceRef?.disabledApproachType !== undefined;
      if (approachData.length === 0) {
        this.educationalServiceIsApproachRequired = false;

        if (canSetDisabledApproachType)
          this.$refs.educationalServiceRef.disabledApproachType = true;
      } else {
        this.services.approachList = approachData;
        this.educationalServiceIsApproachRequired = true;

        if (canSetDisabledApproachType)
          this.$refs.educationalServiceRef.disabledApproachType = false;

        if (this.model.peiAlternatePlacementRecommendedIsSalonRegular) {
          this.services.approachList = approachData.filter(
            (c) => c.id == approachTypes.ServicioMixto
          );
          if (this.services.approachList.length == 1) {
            this.onApproachChange(this.services.approachList[0]);
          }
        }
      }
      this.setApproach();
    },
    setApproach() {
      let approachOption;
      const approachList = this.services.approachList;

      if (this.model.approachTypeId)
        approachOption = {
          id: this.model.approachTypeId,
          name: this.model.approachTypeDescription,
        };
      else approachOption = null;

      if (
        !approachOption ||
        !approachList.find((x) => x.id === approachOption.id)
      ) {
        approachOption = null;
      }

      const educationalServiceRef = this.$refs.educationalServiceRef ?? {};
      educationalServiceRef.selectedApproach = approachOption;
    },
    async loadStudentevaluations() {
      const studentServiceId = this.model.studentServiceId
        ? this.model.studentServiceId
        : '';

      const {
        data: studentEvaluations,
      } = await generalService.getStudentEvaluationServices(
        store.getters.SelectedStudent.studentId,
        this.model.peiAnalysisServiceCode,
        studentServiceId,
        this.peiId
      );
      if (studentEvaluations) {
        this.evaluations = studentEvaluations;
      }

      return studentEvaluations;
    },
    onModalityChange({ id }) {
      if (id) {
        this.model.peiModalityCode = id;

        if (
          this.isDraft &&
          id == modalityTypes.Hogar &&
          this.services.modalityList.length === 1
        ) {
          this.showModalityWarning = true;
        }

        this.disabledEducationalApproachDropDown(id);
        this.loadApproachtypes();

        this.getDurations();
      } else {
        this.educationalServiceIsApproachRequired = true;

        if (
          this.$refs?.educationalServiceRef?.disabledApproachType !== undefined
        )
          this.$refs.educationalServiceRef.disabledApproachType = false;
      }
    },
    onApproachChange({ id }) {
      this.model.approachTypeId = id;
    },
    onFrequencyChange({ id }) {
      this.model.peiFrequencyCode = id;
    },
    onMasterTypeChange({ id }) {
      this.model.peiTeacherTypeCode = id;
    },
    onDurationChange({ id }) {
      this.model.peiDurationCode = id;
    },
    onServiceReasonChange(data) {
      this.model.therapyServiceReason = data;
    },
    onChangeRemedy(value) {
      this.model.provisionalRemedyFlag = value;
    },
    onAddServiceClick() {
      this.evaluations.push(
        {
          id: 1,
          name: 'Psicométrica',
          date: '17/ene./2018',
          adminBy: 'Aida Mendoza Rodríguez',
        },
        {
          id: 2,
          name: 'Psicología',
          date: '20/may./2016',
          adminBy: 'Especialista por Contrato',
        }
      );
    },
    onSaveHandler() {
      this.questionnaireValid = false;
      this.questionnaireStatus = 'Completado';
    },
    onEditHandler() {
      if (this.isDraft) {
        this.getTransportRequestQuestions();
      }
      this.showTransportType = false;
      this.questionnaireValid = true;
    },
    onShowEvaluationHistoryHandler() {},
    async onChangeTranspInfo(item) {
      this.model.transportationRequieredFlag = item.selectedAnswer;
      await this.$ApiPost(`api/pei/servicetransportrequest`, {
        peiId: this.peiId,
        Answer: item.selectedAnswer,
        ServiceId: this.serviceTypeId,
        peiServiceTypeId: this.peiServiceTypeId,
      });
      if (item.selectedAnswer) {
        await this.getTransportRequest();
        await this.getTransportRequestQuestions(this.isPS);
      }
    },
    async getTransportRequestQuestions(autoFill) {
      if (
        this.requiredTransportation != null &&
        this.canShowTransportationSectionForPS
      ) {
        this.transportRequestQuestion = [];

        let idQuestionary = this.requiredTransportation.id;

        let response = await this.$ApiGet(
          `api/pei/gettransportrequestquestions/${this.peiId}/${idQuestionary}`,
          {
            peiServiceTypeId: this.peiServiceTypeId,
          }
        );
        const regularTransportHasValue =
          this.model?.peiSchoolHasRegularTransport !== null &&
          this.model?.peiSchoolHasRegularTransport !== undefined;
        const requiresTransport =
          this.isDraft && this.model.transportationRequieredFlag;

        if (requiresTransport && this.isEducativeService) {
          (response.data || []).forEach(({ questions }) => {
            if (
              regularTransportHasValue &&
              this.model.peiTransportationStatus !== PeiCode.Beca
            ) {
              const question = questions.find(
                (x) =>
                  x.id ==
                  transportationQuestionnaireEnum.section_2_question_1_hasRegularTransport
              );
              // if the school has regular transport then set the question to YES or NO then show it as selected
              if (question) {
                question.defaultOptionValueSelected = this.model
                  ?.peiSchoolHasRegularTransport
                  ? yesOrNotEnum.yes
                  : yesOrNotEnum.no;
                question.disabled = true;
                question.warningMessage =
                  'Esta pregunta está preseleccionada basada en si la escuela cuenta con una ruta regular que sirva a la escuela.';

                const selectedAnswer = question.answers?.find(
                  (x) => x.id === question.defaultOptionValueSelected
                );
                if (selectedAnswer) selectedAnswer.isSelected = true;
              }
            }

            // US119163: if draft and requires transportation marked as YES then check if cognitiveAnswer is mark as YES in Define PEI question #7
            // if true then set question-id 199 to YES
            if (this.model.cognitiveAnswer === true) {
              const question_significativeImpediment = questions.find(
                (x) =>
                  x.id ==
                  transportationQuestionnaireEnum.section_2_question_1_significant_impediment
              );

              if (question_significativeImpediment) {
                question_significativeImpediment.defaultOptionValueSelected =
                  yesOrNotEnum.yes;
                question_significativeImpediment.disabled = true;
                question_significativeImpediment.warningMessage =
                  'Esta pregunta está preseleccionada basada en la contestación de la pregunta 7. ¿El estudiante tiene un impedimento cognoscitivo significativo? del Define PEI.';

                const yesAnswer = question_significativeImpediment.answers?.find(
                  (x) => x.id === yesOrNotEnum.yes
                );
                if (yesAnswer) yesAnswer.isSelected = true;
              }
            }
          });
        }

        this.transportRequestQuestion = response.data;

        // autoFill is only set onChangeTranspInfo when true
        if (autoFill) {
          (this.transportRequestQuestion || []).forEach(({ questions }, i) => {
            questions.forEach(({ answers }, y) => {
              const isQuestion1Section2 = i == 1 && y == 0; // This question should be answered as yes, otherwise no
              const [yes, no] = answers;
              yes.isSelected = isQuestion1Section2;
              no.isSelected = !isQuestion1Section2;
            });
          });
          this.serviceQuestionnaireKey = uniqueId();
          // We need to wait to nextTick since serviceQuestionnaire need to computed some stuff internally
          this.$nextTick(async () => {
            // Save transportation question with default values for PS
            const serviceQuestionnaireRef = this.$refs.serviceQuestionnaire;
            await serviceQuestionnaireRef.SaveTransportQuestionnarie(false);
            this.serviceQuestionnaireKey = uniqueId();
          });
        }
      }
    },
    async getTransportRequest() {
      let { data: response } = await this.$ApiGet(
        `api/pei/getservicetransportrequest/${this.peiId}/${this.serviceTypeId}`
      );

      if (response && response !== '') {
        this.requiredTransportation = response;
        this.showTransportType = response.state;

        if (response.status == null) {
          this.questionnaireStatus = 'Pendiente';
          this.questionnaireValid = true;
        } else {
          this.questionnaireStatus = response.state
            ? 'Completado'
            : 'Pendiente';
          this.questionnaireValid = response.state ? false : true;

          //-1. show warning message to speak up 1. No required, 2. Regular, 3.Carrier, 4.Scholarship
          if (response.status.id == 0) {
            this.transportType = '-1';
            this.model.peiTransportationStatus = null;
          } else {
            this.transportType = response.status.id + '';
            this.model.peiTransportationStatus = response.status.id;
          }
        }
      }
    },
    async updateAnalisysServiceData() {
      this.requiredTransportation = null;
      await this.getTransportRequest();
    },

    disabledEducationalApproachDropDown(id) {
      //disabled approach dropdown for modality <> 'Hogar - 497' and 'Salon Regular - 495'
      if (this.educationServiceControlCode == this.model.visualControlCode) {
        const educationalServiceRef = this.$refs.educationalServiceRef ?? {};
        if (!APPROACH_TYPE_ENABLED_ITEMS.includes(id)) {
          educationalServiceRef.disabledApproachType = true;
        } else {
          educationalServiceRef.disabledApproachType = false;
        }
      }
    },
    isAdaptedPhysicalEducationCombine() {
      return (
        this.peiAnalysisService.EducacionFisicaAdaptadaCombinada ===
        this.peiServiceTypeId
      );
    },
    setDurationData() {
      let durationOption;

      if (this.model.peiDurationCode)
        durationOption = {
          id: this.model.peiDurationCode,
          name: this.model.peiDurationDescription,
        };
      else durationOption = null;

      const durations = this.services.durationList;

      if (
        durations.length == 0 ||
        durationOption === null ||
        !durations.find((x) => x.id == durationOption.id)
      ) {
        durationOption = null;
      }

      const serviceRef =
        this.$refs.educationalServiceRef || this.$refs.deafServiceRef;

      if (serviceRef) {
        serviceRef.selectedDuration = durationOption;
      }
    },
    async getDurations() {
      let result = [];
      // educative service
      if (this.enableEducationServiceControl) {
        const { data: educationData } = await this.loadEducationDuration();
        if (educationData) {
          result = educationData;
        }
      } else {
        const { data: therapyData } = await this.loadTherapyDuration();
        if (therapyData) {
          result = therapyData;
        }
      }

      this.services.durationList = result;

      this.setDurationData();
    },
    async getTransportationAddress(locationTypeId, addressTypeId) {
      return await this.$ApiGet(
        `/api/pei/analysisservicetransportationaddress?analysisServiceId=${this.model.analysisServiceId}&locationTypeId=${locationTypeId}&addressTypeId=${addressTypeId}`
      );
    },
    async getDepartureData(code) {
      let { data } = await this.getTransportationAddress(
        code,
        transportationServiceAddressTypes.departure
      );
      this.transportationModel.departure = data;
    },
    async getPlaceData(code) {
      let { data } = await this.getTransportationAddress(
        code,
        transportationServiceAddressTypes.place
      );
      this.transportationModel.place = data;
    },
  },
  async mounted() {
    window.scrollTo(0, 0);

    this.loadResources();

    //get init analysis service
    await this.initAnalysisService();

    //get transportation question
    await this.getTransportRequest();

    const academicYearId = store.getters.getPeiInfo.academicYearId;

    const { data } = await getSysparameterByNames({
      parameterNames: [
        'ActivateAssistantServiceNeedGuide',
        'EnableAlwaysVisibleTransportationQuestionnaire',
      ],
      academicYearId,
    });
    this.activateAssistantServiceNeedGuideIsOn = data[0]?.staticValue == 'true';
    this.enableAlwaysVisibleTransportationQuestionnaireParam =
      data[1]?.staticValue == 'true';

    // Si el parametro de cuestionario siempre visible esta encendido, setear transportationRequieredFlag a true automáticamente
    // y crear transportRequest si no existe (solo si la sección de transportación se va a mostrar)
    if (this.isNewTransportationLogic && this.canShowTransportationDiv) {
      this.model.transportationRequieredFlag = true;

      if (this.requiredTransportation == null) {
        await this.$ApiPost(`api/pei/servicetransportrequest`, {
          peiId: this.peiId,
          Answer: true,
          ServiceId: this.serviceTypeId,
          peiServiceTypeId: this.peiServiceTypeId,
        });
        await this.getTransportRequest();
      }
    }

    await this.getTransportRequestQuestions();

    // apply disabled-all if pei status is different to 'Borrador'
    this.disabledAll = this.isNotDraft;

    if (this.disabledAll || this.isPS) {
      this.setTransportationDisability(true);
    }

    let transportInfo = await store.state.peiTransportationInfo;
    if (transportInfo) {
      this.transportationModel.serviceType = this.peiServiceTypeId;
      this.transportationModel.departureCode = transportInfo.departureCode;
      this.transportationModel.acompanyCode = transportInfo.acompanyCode;
      this.transportationModel.endDate = transportInfo.endDate;
      this.transportationModel.startDate = transportInfo.startDate;
      this.transportationModel.placeCode = transportInfo.placeCode;
      this.transportationModel.mileage = transportInfo.millaje;
      this.transportationModel.justification =
        transportInfo.justification || '';
      this.transportationModel.specialEquipmentCode =
        transportInfo.specialEquipmentCode;

      if (transportInfo.departureCode) {
        this.getDepartureData(transportInfo.departureCode);
      }

      if (transportInfo.placeCode) {
        this.getPlaceData(transportInfo.placeCode);
      }
    }
  },
  components: {
    breadcrumb,
    SectionTitle,
    WizardQuestion,
    ServiceQuestionnaire,
    EducationalService,
    TherapyService,
    DeafService,
    AdaptedPhysicalEducationService,
    ValidationProvider,
    ValidationObserver,
    ServiceDocument,
    ServiceEvaluation,
    Error,
    ServiceStatusInfo,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.search-box {
  display: flex;
  flex-direction: row;
}

.info-title {
  padding: 10px;
}

.main-title {
  margin-bottom: 30px;
}

.info-title p {
  margin-top: -40px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.main-content {
  margin: 0px;
  padding: 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.separator-box {
  margin-top: 40px;
}
</style>
